import { render, staticRenderFns } from "./tabSubBillUICustomLayout.vue?vue&type=template&id=37739907&"
import script from "./tabSubBillUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabSubBillUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37739907')) {
      api.createRecord('37739907', component.options)
    } else {
      api.reload('37739907', component.options)
    }
    module.hot.accept("./tabSubBillUICustomLayout.vue?vue&type=template&id=37739907&", function () {
      api.rerender('37739907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBillUICustomLayout.vue"
export default component.exports